import { render, staticRenderFns } from "./DoubleVisitReport.vue?vue&type=template&id=8a851c8e&scoped=true"
import script from "./DoubleVisitReport.vue?vue&type=script&lang=js"
export * from "./DoubleVisitReport.vue?vue&type=script&lang=js"
import style0 from "./DoubleVisitReport.vue?vue&type=style&index=0&id=8a851c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a851c8e",
  null
  
)

export default component.exports